import {
  AgxSelectChip,
  AgxSpacer,
  AgxTextInput,
  Icon_MagnifyingGlass,
  SelectChipOption,
} from '@urbanx/agx.ui-components2';

import './CampaignsDashboard.scss';
import { useDebouncedState } from '@urbanx/agx-ui-components';
import { useEffect } from 'react';

interface CampaignsDashboardHeaderProps {
  addressSearchText: string;
  agencyFilterOptions: SelectChipOption[];
  selectedCampaignStatusOptions: SelectChipOption[];
  selectedContractStatusOptions: SelectChipOption[];
  selectedLaunchDateStatusOptions: SelectChipOption[];
  selectedMarketingStatusOptions: SelectChipOption[];
  onAddressSearchTextChange: (value: string) => void;
  handleAgencyFilterSelect: (options: SelectChipOption[]) => void;
  handleCampaignStatusFilterSelect: (options: SelectChipOption[]) => void;
  handleContractFilterSelect: (options: SelectChipOption[]) => void;
  handleLaunchDateFilterSelect: (options: SelectChipOption[]) => void;
  handleMarketingFilterSelect: (options: SelectChipOption[]) => void;
  resetAgencyFilters: () => void;
  resetCampaignStatusFilters: () => void;
  resetContractFilters: () => void;
  resetLaunchDateFilters: () => void;
  resetMarketingFilters: () => void;
}

const CampaignsDashboardHeader = ({
  addressSearchText,
  agencyFilterOptions,
  selectedCampaignStatusOptions,
  selectedContractStatusOptions,
  selectedLaunchDateStatusOptions,
  selectedMarketingStatusOptions,
  onAddressSearchTextChange,
  handleAgencyFilterSelect,
  handleCampaignStatusFilterSelect,
  handleContractFilterSelect,
  handleLaunchDateFilterSelect,
  handleMarketingFilterSelect,
  resetAgencyFilters,
  resetCampaignStatusFilters,
  resetContractFilters,
  resetLaunchDateFilters,
  resetMarketingFilters,
}: CampaignsDashboardHeaderProps) => {
  const [searchText, setSearchText] = useDebouncedState(addressSearchText, 500);

  useEffect(() => {
    onAddressSearchTextChange(searchText);
  }, [onAddressSearchTextChange, searchText]);

  return (
    <AgxSpacer
      fill
      contentAlignment="center"
      direction="horizontal"
      className="campaignDashboardFilters"
    >
      <AgxSpacer className="campaignDashboardSearch">
        <AgxTextInput
          id={'address-search'}
          type={'text'}
          placeholder={'Search by address'}
          defaultValue={addressSearchText}
          border="rounded"
          hideOptionalText
          leftIcon={
            <Icon_MagnifyingGlass color="var(--fg-tertiary, #B9B9B9)" height={15} width={15} />
          }
          onChange={(v) => setSearchText(v)}
          minWidth="320px"
          noHeader
        />
      </AgxSpacer>
      <AgxSpacer
        direction="horizontal"
        gap="xs"
        contentJustification="end"
        className="campaignDashboardFilterControls"
        wrap
      >
        <AgxSelectChip
          id="campaign-dashboard-agency-filter"
          options={agencyFilterOptions}
          hideSelectAll
          variant="chip"
          type="multi-select"
          size="medium"
          align="right"
          label="Agency"
          searchPlaceHolder="Search agencies"
          onSelect={handleAgencyFilterSelect}
          onReset={resetAgencyFilters}
        />
        <AgxSelectChip
          id="campaign-dashboard-status-filter"
          options={selectedCampaignStatusOptions}
          hideSelectAll
          variant="chip"
          type="multi-select"
          size="medium"
          align="right"
          label="Campaign Status"
          onSelect={handleCampaignStatusFilterSelect}
          onReset={resetCampaignStatusFilters}
        />
        <AgxSelectChip
          id="campaign-dashboard-contract-filter"
          options={selectedContractStatusOptions}
          hideSelectAll
          variant="chip"
          type="multi-select"
          size="medium"
          align="right"
          label="Contract"
          onSelect={handleContractFilterSelect}
          onReset={resetContractFilters}
        />
        <AgxSelectChip
          id="campaign-dashboard-launch-filter"
          options={selectedLaunchDateStatusOptions}
          hideSelectAll
          variant="chip"
          type="multi-select"
          size="medium"
          align="right"
          label="Launch Date"
          onSelect={handleLaunchDateFilterSelect}
          onReset={resetLaunchDateFilters}
        />
        <AgxSelectChip
          id="campaign-dashboard-marketing-filter"
          options={selectedMarketingStatusOptions}
          hideSelectAll
          variant="chip"
          type="multi-select"
          size="medium"
          align="right"
          label="Marketing"
          onSelect={handleMarketingFilterSelect}
          onReset={resetMarketingFilters}
        />
      </AgxSpacer>
    </AgxSpacer>
  );
};

export default CampaignsDashboardHeader;
